import { IExampleDrivers, IExampleLocation } from './interfaces';

const drivers: IExampleDrivers = {
  name: `Santiago de Chile`,
  location: {
    lat: -33.447487,
    lng: -70.673676,
  },
  drivers: {
    label: [`Tomás`, `Gaspar`, `Vicente`],
    start_address: [
      `Avda Libertador Bernardo O'Higgins 776, Piso 4, Santiago, Región Metropolitana, Chile`,
      `Avda Libertador Bernardo O'Higgins 776, Piso 4, Santiago, Región Metropolitana, Chile`,
      `Avda Libertador Bernardo O'Higgins 776, Piso 4, Santiago, Región Metropolitana, Chile`,
    ],
    end_address: [
      `Monjitas 527, Oficina 1305, Santiago, Región Metropolitana, Chile`,
      `Avda Libertador Bernardo O'Higgins 776, Piso 4, Santiago, Región Metropolitana, Chile`,
      `Avda Libertador Bernardo O'Higgins 776, Piso 4, Santiago, Región Metropolitana, Chile`,
    ],
  },
};

const stops: IExampleLocation = {
  name: `Santiago de Chile`,
  location: {
    lat: -33.447487,
    lng: -70.673676,
  },
  stops: {
    label: [
      `Il Pazzo`,
      `Brasur Restaurante`,
      `Bocanáriz`,
      `Chipe Libre`,
      `Como Agua para Chocolate`,
      `Peumayen Ancestral Food`,
      `Castillo Forestal`,
      `Ocean Pacific's Buque Madre`,
      `Ambrosía`,
      `Le Bistrot Viet`,
    ],
    address: [
      `Alonso de Córdova 5320, Las Condes, Región Metropolitana, Chile`,
      `San Antonio 434, local 8, Santiago, Región Metropolitana, Chile`,
      `José Victorino Lastarria 276, Santiago, Región Metropolitana, Chile`,
      `José Victorino Lastarria 282, Santiago, Región Metropolitana, Chile`,
      `Constitución 88, Santiago, Providencia, Región Metropolitana, Chile`,
      `Constitución 136, Providencia, Región Metropolitana, Chile`,
      `Cardenal José María Caro 390, Santiago, Región Metropolitana, Chile`,
      `Av. Ricardo Cumming 221, Santiago, Región Metropolitana, Chile`,
      `Pamplona 78, Santiago, Vitacura, Región Metropolitana, Chile`,
      `Padre Luis de Valdivia 327, Santiago, Región Metropolitana, Chile`,
    ],
    address_details: [``, ``, `Piso 1 Puerta 3`, ``, `4º 5ª`, ``, `2ºB`, ``, ``, `4F`],
    delivery_label: [
      `Mateo Gonzalez`,
      `Agustín Muñoz`,
      `Josefa Miranda`,
      `Tomás Díaz`,
      `Benjamín Perez`,
      `Lucas Soto`,
      `Gaspar Contreras`,
      `Alonso Silva`,
      `Martín Vargas`,
      `Santiago Rojas`,
    ],
    delivery_address: [
      `Agustinas 1352, Santiago, Región Metropolitana, Chile`,
      `Eliodoro Yañez 1759, Providencia, Región Metropolitana, Chile`,
      `Los Militares 6735, Santiago, Las Condes, Región Metropolitana, Chile`,
      `Paseo Ahumada 370, Santiago, Región Metropolitana, Chile`,
      `Hendaya 344, Santiago, Las Condes, Región Metropolitana, Chile`,
      `Eliodoro Yañez 1759, Providencia, Región Metropolitana, Chile`,
      `Av Vitacura 9910, Vitacura, Región Metropolitana, Chile`,
      `Lo Fontecilla 101, Santiago, Las Condes, Región Metropolitana, Chile`,
      `Holanda 099, Santiago, Providencia, Región Metropolitana, Chile`,
      `Paseo Ahumada 312, Santiago, Región Metropolitana, Chile`,
    ],
    delivery_address_details: [``, ``, ``, ``, `6º 1ª`, ``, `Bajos 1`, ``, ``, `Local`],
  },
};

export { drivers, stops };
